import { showError, showSuccess } from '../../../common/A1Alert/A1Alert';
import Api from '../../../helpers/Api';


// ACTION  TYPE

export const SET_SINGLE_PROMOTION_DATA = 'SET_SINGLE_PROMOTION_DATA';
const setSinglePromotionData = (data) => ({
    type: SET_SINGLE_PROMOTION_DATA,
    data,
});

export const SET_LAST_SLUG = 'SET_LAST_SLUG';
const setLastSlug = (data) => ({
    type: SET_LAST_SLUG,
    data,
});

export const SET_PROMOTION_WINNERS = 'SET_PROMOTION_WINNERS';
const setPromotionWinners = (data) => ({
    type: SET_PROMOTION_WINNERS,
    data,
});

export const SET_LAST_PROMOTION_WINNERS_ID = 'SET_LAST_PROMOTION_WINNERS_ID';
const setLastIdPromotionWinners = (data) => ({
    type: SET_LAST_PROMOTION_WINNERS_ID,
    data,
});

export const SET_USER_ANWSER = 'SET_USER_ANWSER';
const setUserAnswer = (data) => ({
    type: SET_USER_ANWSER,
    data,
});

export const SET_LAST_USER_ANSWER = 'SET_LAST_USER_ANSWER';
const setLastPromotionAnswer = (data) => ({
    type: SET_LAST_USER_ANSWER,
    data,
});

export const RESET_PROMOTION_DATA = 'RESET_PROMOTION_DATA';

export const resetPromotionData = () => (dispatch) => {
    dispatch({
        type: RESET_PROMOTION_DATA,
    });
};

export const IS_FETCHING = 'IS_FETCHING';
const setIsFetching = () => ({
    type: IS_FETCHING,
});

export const END_FETCHING = 'END_FETCHING';
const setEndFetching = () => ({
    type: END_FETCHING,
});

export const SET_NOT_FOUND = 'SET_NOT_FOUND';

export const setNotFound = (notFound) => ({
    type: SET_NOT_FOUND,
    notFound,
});

// ACTION

export const fetchSinglePromotionIfNeeded = (slug) => (dispatch, getState) => {
    const { lastSlug } = getState().promotions.singlePromotions;

    if (lastSlug === slug) {
        // we already have the necessary data
        return Promise.resolve(1);
    }

    dispatch(setNotFound(false));

    return Api.progressGet(dispatch, `/api/v1/promotions/getPromotionBySlug/${slug}`).then((json) => {
        if (json.status === 'success') {
            const allPromisses = [
                dispatch(setSinglePromotionData(json.data)),
                dispatch(setLastSlug(slug)),
            ];

            return Promise.all(allPromisses);
        }

        if (json.status === 404) {
            const allPromisses = [
                dispatch(setNotFound(true)),
                dispatch(setLastSlug(slug)),
            ];

            return Promise.all(allPromisses);
        }

        throw `error from server: ${json.message}`;
    }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log('There has been a problem with your fetch operation: ', error);
    });
};

export const fetchPromotionWinners = (idPromotion) => (dispatch, getState) => {
    const { lastPromotionWinnerId } = getState().promotions.singlePromotions;

    if (idPromotion !== lastPromotionWinnerId) {
        dispatch(setIsFetching());

        return Api.progressGet(dispatch, `/api/v1/promotions/getPromotionWinners/${idPromotion}`).then((json) => {
            if (json.status === 'success') {
                const allPromisses = [
                    dispatch(setPromotionWinners(json.data)),
                    dispatch(setLastIdPromotionWinners(idPromotion)),
                ];

                return Promise.all(allPromisses)
                    .then(() => {
                        dispatch(setEndFetching());
                    });
            }

            showError('Nenhum ganhador encontrado para essa promoção.');

            dispatch(setEndFetching());

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.log('There has been a problem with your fetch operation: ', error);
        });
    }

    return Promise.resolve(1);
};


export const fetchUserAnswer = (idPromotion, makeRequest = false) => (dispatch, getState) => {
    // the user needs to be logged in before calling this function.
    // the userId will come from passport!
    const { lastPromotionAnswer } = getState().promotions.singlePromotions;

    // Checks if already got  promotion`s answer
    if (idPromotion !== lastPromotionAnswer || makeRequest) {
        dispatch(setIsFetching());

        const query = `/api/v1/promotions/getUserAnswer/${idPromotion}`;
        const token = getState().profile.jwt;

        return Api.progressGet(dispatch, query, token).then((json) => {
            if (json.status === 'success') {
                const myPromises = [
                    dispatch(setUserAnswer(json.data)),
                    dispatch(setLastPromotionAnswer(idPromotion)),
                ];

                // NOTE: here there is no need to wait all the Promises to finish because this page will never be crawled by google as a logged in user
                // and we can se endfetching right away, updating the store is mostly instantanous...
                return Promise.all(myPromises)
                    .then(() => {
                        dispatch(setEndFetching());
                    });
            }

            const myPromises = [
                dispatch(setUserAnswer(false)),
                dispatch(setLastPromotionAnswer(idPromotion)),
            ];

            return Promise.all(myPromises)
                .then(() => {
                    dispatch(setEndFetching());

                    throw `error from server: ${json.message}`;
                });
        }).catch((error) => {
            dispatch(setEndFetching());

            // eslint-disable-next-line no-console
            console.log('There has been a problem with your fetch operation: ', error);
        });
    }

    return Promise.resolve(1);
};


export const saveAnswer = (idUserPromotion, idPromotion, answer, callBack) => (dispatch, getState) => {
    // the user needs to be logged in before calling this function.
    // the userId will come from passport!
    dispatch(setIsFetching());

    const query = '/api/v1/promotions/saveAnswer';
    const token = getState().profile.jwt;
    const data = {
        idUserPromotion,
        idPromotion,
        answer,
    };

    return Api.progressPost(dispatch, query, data, token).then((json) => {
        if (json.status === 'success') {
            showSuccess('Sua resposta foi enviada com sucesso :)');

            callBack('success');

            return dispatch(fetchUserAnswer(idPromotion, true));
            // @TODO return the answer (and necessary additional data) (if necessary) directly instead of doing another request
        }

        throw `error from server: ${json.message}`;
    }).catch((error) => {
        dispatch(setEndFetching());

        showError('Ocorreu um erro inesperado :( Tente novamente mais tarde.');

        // eslint-disable-next-line no-console
        console.log('There has been a problem with your fetch operation: ', error);

        callBack('error');
    });
};
